<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="5" style="margin-bottom: 15px">
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="dorData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expand-all="true"
              @node-click="choose"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="19" style="margin-bottom: 15px">
          <ele-data-table ref="table" :config="table" height="calc(100vh - 200px)" highlight-current-row>
            <template>
              <el-table-column prop="roomName" label="宿舍名称" sortable="custom" show-overflow-tooltip min-width="110" />
              <el-table-column prop="id" label="宿舍代码" sortable="custom" show-overflow-tooltip min-width="110" />
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import { getDormitoryStoreyStructureTree } from '@/config/api';

  export default {
    name: 'DorCode',
    data() {
      return {
        loading: true, // 加载状态
        dorData: [], // 列表数据
        table: {
          // 表格配置
          url: '/school/dormitory/getRoomListByStoreyId',
          where: {
            storeyId: '',
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
      };
    },
    mounted() {
      this.query();
    },
    methods: {
      query() {
        this.loading = true;
        getDormitoryStoreyStructureTree().then((res) => {
          this.loading = false;
          if (res.data.resCode == 200) {
            this.dorData.push(res.data.data[0]);
            setTimeout(() => {
              this.choose(this.dorData[0].children[0].children[0]);
            }, 100);
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      /* 选择数据 */
      choose(row) {
        if (row.orgType === 3) {
          this.$refs.orgTree.setCurrentKey(row.id);
          this.table.where.storeyId = row.id.slice(1);
          this.$refs.table.reload();
        }
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 35px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
